
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gafi2JiLY860_V4Wg34rhzsC1SOqTnPlGvZUt0C0O4UYMeta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexhY_tVaEMBpmMLX8mCpT7sNFJLBxq3FBrAcwHhCmsj1gMeta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchiI7_45GcDwhfIoeN1Ti9M0GopoBuntZqPHd1ac8E7uw6cMeta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexD_YQldQswm5zT0vLNdKjF766YxpT8zMdyq8eoUgfQFIMeta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93TBEJH_45R4_SOnVDOZT4VwSQL1gjZUHchTHCvnX4_45wXAgMeta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexALdvZkUukkXS31iVqkcKmR2y7BswbJ6Sc7yGaADyK4sMeta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93tgKeSlTu6FJDeoHOf3YTi6Xk0M7lFBc0jxccH6hmGUAMeta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index2fqO4NBV0zN9_45gKO_450GutfaUqq_45xo3yn2AoL0fUz_kwMeta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93S9faRdw3Cz7NvhYXqOgQR4Ik6bg6JGGqoJm6I4cn54oMeta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexPCvprqpjYqc4YhrNZTDzvRpD_45Yfx_SV7T2vQuKs4sX0Meta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexinOavmKJ_45ASL8BDRLj3zKrmYKDmrUaDaI9Zy5_6knZsMeta } from "/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexALdvZkUukkXS31iVqkcKmR2y7BswbJ6Sc7yGaADyK4sMeta || {},
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index2fqO4NBV0zN9_45gKO_450GutfaUqq_45xo3yn2AoL0fUz_kwMeta || {},
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexPCvprqpjYqc4YhrNZTDzvRpD_45Yfx_SV7T2vQuKs4sX0Meta || {},
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexinOavmKJ_45ASL8BDRLj3zKrmYKDmrUaDaI9Zy5_6knZsMeta || {},
    component: () => import("/codebuild/output/src2366087686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]